import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios"
import { unFormatUnit } from "@/common/utils/unFormatters"
import { CreateWorkflowSchedulesSchema } from "../services/workflowSchedules.schema"
import { CompanyData } from "@/features/company/types/company.type"

interface UseCreateMaintenanceWorkflowScheduleProps {
  companyData?: CompanyData
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: any) => void
}

const useCreateMaintenanceWorkflowSchedule = ({ companyData, onSuccess, onError }: UseCreateMaintenanceWorkflowScheduleProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createMaintenanceWorkflowSchedule'],
    mutationFn: async (form: CreateWorkflowSchedulesSchema) => {
      const workflow_schedule = {
        display_name: form.display_name,
        kind: form.kind?.value,
        company_id: companyData?.id || undefined,
        observations: form.observations || undefined,
        equipment_category_ids: form.equipment_category_ids ? [form.equipment_category_ids.value] : undefined,
        branch_ids: form.branch_ids ? form.branch_ids.map((item) => item.value) : undefined,
        manufacturer_ids: form.manufacturer_ids ? form.manufacturer_ids.map((item) => item.value) : undefined,
        equipment_model_ids: form.equipment_model_ids ? form.equipment_model_ids.map((item) => item.value) : undefined,
        equipment_ids: form.equipment_ids ? form.equipment_ids.map((item) => item.value) : undefined,
        interval_in_kilometers_usage: form.interval_in_kilometers_usage ? unFormatUnit(form.interval_in_kilometers_usage, 'Km') : undefined,
        interval_in_days: form.interval_in_days ? unFormatUnit(form.interval_in_days, 'Dias') : undefined,
        interval_in_hours_usage: form.interval_in_hours_usage ? unFormatUnit(form.interval_in_hours_usage, 'H') : undefined,
        objectives_attributes: form.objectives_attributes?.map((objective) => ({
          system_id: objective.system_id.value,
          part_id: objective.part_id.value,
          action_id: objective.action_id.value,
        }))
      }

      return privateAxios.post(`/maintenance/workflow_schedules`, { workflow_schedule })
    },
    onSuccess,
    onError,
  })
}

export default useCreateMaintenanceWorkflowSchedule

